/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationUserRequestDto
 */
export interface CreateOrganizationUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    role: CreateOrganizationUserRequestDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    language: CreateOrganizationUserRequestDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserRequestDto
     */
    phone?: string;
}


/**
 * @export
 */
export const CreateOrganizationUserRequestDtoRoleEnum = {
    OrganizationManager: 'ORGANIZATION_MANAGER',
    Supervisor: 'SUPERVISOR',
    FieldTechnician: 'FIELD_TECHNICIAN'
} as const;
export type CreateOrganizationUserRequestDtoRoleEnum = typeof CreateOrganizationUserRequestDtoRoleEnum[keyof typeof CreateOrganizationUserRequestDtoRoleEnum];

/**
 * @export
 */
export const CreateOrganizationUserRequestDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type CreateOrganizationUserRequestDtoLanguageEnum = typeof CreateOrganizationUserRequestDtoLanguageEnum[keyof typeof CreateOrganizationUserRequestDtoLanguageEnum];


/**
 * Check if a given object implements the CreateOrganizationUserRequestDto interface.
 */
export function instanceOfCreateOrganizationUserRequestDto(value: object): value is CreateOrganizationUserRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function CreateOrganizationUserRequestDtoFromJSON(json: any): CreateOrganizationUserRequestDto {
    return CreateOrganizationUserRequestDtoFromJSONTyped(json, false);
}

export function CreateOrganizationUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'password': json['password'],
        'role': json['role'],
        'language': json['language'],
        'organizationId': json['organizationId'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function CreateOrganizationUserRequestDtoToJSON(json: any): CreateOrganizationUserRequestDto {
    return CreateOrganizationUserRequestDtoToJSONTyped(json, false);
}

export function CreateOrganizationUserRequestDtoToJSONTyped(value?: CreateOrganizationUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'password': value['password'],
        'role': value['role'],
        'language': value['language'],
        'organizationId': value['organizationId'],
        'phone': value['phone'],
    };
}

